import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

const Whychooseusa = () => {
  return (
    <div className="whychooseusa p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>
              <span>Why Choose</span> TekRevol As Your Trusted Enterprise App
              Development Company?
            </h2>
          </Col>
        </Row>
        <Row className="h-100 choose_padd">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <p>
              Choosing TekRevol as your trusted enterprise app development
              company comes with a range of benefits. Our commitment to
              delivering practical and effective solutions sets us apart in the
              industry.
            </p>
            <p>
              With a focus on meeting the unique needs of businesses, we bring a
              track record of successful collaborations with startups and
              enterprises alike.
            </p>
            <p>
              What sets us apart is our versatility in offering both native and
              cross-platform enterprise mobile app development.
            </p>
            <p>
              This flexibility ensures that your applications reach a wider
              audience without compromising performance or user experience.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Schedule A Free Consultation Session
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={7} xxl={7}>
            <StaticImage
              src="../../images/services-usa/enterprise-app/why-choose.webp"
              alt="Enterprise Mobile App Development Company"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={775}
              height={650}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Whychooseusa;
